"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var _api = require("@lce/api");

var _Cart = _interopRequireDefault(require("../Cart/Cart"));

var _CartIcon = _interopRequireDefault(require("../CartIcon"));

var _useCart = _interopRequireDefault(require("../../useCart"));

var Styled = _interopRequireWildcard(require("./Modal.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var Modal = function Modal() {
  var _a = (0, _react.useState)(false),
      isOpen = _a[0],
      setIsOpen = _a[1];

  var onClose = function onClose() {
    return setIsOpen(false);
  };

  var toggleOpen = function toggleOpen() {
    return setIsOpen(!isOpen);
  };

  var addItems = (0, _useCart["default"])().addItems;
  (0, _api.useDeepLinkCart)({
    addItems: addItems
  });
  return _react["default"].createElement(_slice.Box, null, _react["default"].createElement(Styled.A11yButton, {
    "data-testid": "Modal__AllyButton",
    onClick: toggleOpen
  }, _react["default"].createElement(_CartIcon["default"], null)), _react["default"].createElement(_slice.Layer, {
    closeOnClickOutside: true,
    isOpen: isOpen,
    lockBodyScroll: true,
    onClose: onClose,
    overlay: false
  }, _react["default"].createElement(Styled.Modal, {
    alignItems: "stretch",
    backgroundColor: "orange",
    flexDirection: "column",
    width: "100%"
  }, _react["default"].createElement(Styled.Cart, {
    "data-testid": "Modal__Cart"
  }, _react["default"].createElement(_Cart["default"], {
    onClose: onClose
  })))));
};

exports.Modal = Modal;
var _default = Modal;
exports["default"] = _default;